
import { debounceTime } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params, RouterLink } from '@angular/router';
import { NgForm } from '@angular/forms';
import { DeletePopupComponent } from '../Popups/delete-popup/delete-popup.component';
import { MatDialog } from '@angular/material';
import { OrganizationService } from '../../shared/services/organization.service';
import { error } from 'util';
import { MatSnackBar } from '@angular/material';
import { AuthService } from '../../shared/services/auth/auth.service';
import { StaticValueService } from '../../shared/services/static-value.service';
import { NotificationService } from '../../shared/services/notification.service';
import { AssociateService } from 'app/associate/shared/services/associate.service';
import { ToastService } from '../../shared/services/toast.service';
import { Location } from '@angular/common';
import { Configuration } from '../../app.constants';
import { Sort } from '@angular/material';


@Component({
    selector: 'app-site-profile',
    templateUrl: './site-profile.component.html',
    styleUrls: ['./site-profile.component.css']
})
export class SiteProfileComponent implements OnInit {
    @ViewChild('myForm')
    public myForm: NgForm;
    public site: any;
    public organization: any;
    public siteAssociates = [];
    public originalSiteLeaderId: string;
    public apiServerUrl;

    // public lat: Number = 33.6843;
    // public lng: Number = 72.9885;

    // variable for ACL
    public isAssociate: Boolean = true;
    public isAdmin: Boolean = false;
    public isLeader: Boolean = false;
    public hrLeaderId: string;
    public companyLeaderId: string;

    // dropDowns Object
    public dropDowns = {};

    // boolean to toggle edit functionality0
    public canValidate: Boolean = false;
    public siteDetailsEdit: Boolean;
    public contactDetailsEdit: Boolean;
    public siteAddressDetailsEdit: Boolean;

    // individual objects for cards
    public siteDetails: any;
    public contactDetails: any;
    public siteAddressDetails: any;

    // autocomplete
    public autoCompleteAssociate: any;
    public keyCounterAssc = 0;
    public errors: any;

    public digitalSiteList = [];
    public physicalSiteList = [];
    public sitePurposeDropDown = [];
    public staticDDlist = [];
    public mask;


    constructor(public dialog: MatDialog,
        public route: ActivatedRoute,
        public router: Router,
        public organizationService: OrganizationService,
        public matSnackBar: MatSnackBar,
        public authService: AuthService,
        public staticDDlistService: StaticValueService,
        public notificationService: NotificationService,
        public associateService: AssociateService,
        public toastService: ToastService,
        public _location: Location,
        public config: Configuration) { }
    assignCardObjects() {
        this.siteDetails = JSON.parse(JSON.stringify(this.site.siteDetails));
        // this.siteAddressDetails  = JSON.parse(JSON.stringify(this.site.siteAddressDetails));
        this.contactDetails = JSON.parse(JSON.stringify(this.site.contactDetails));
        this.originalSiteLeaderId = this.contactDetails.siteLeader.id; // for comparison at the end
        this.onTypeChange();
    }

    ngOnInit() {
        // mask for phone number
        this.mask = this.authService.phoneNumberMaskObject;
        this.staticDDlist = this.staticDDlistService.staticData.staticDD;
        this.digitalSiteList = JSON.parse(JSON.stringify(this.staticDDlist['site']['digitalType']));
        this.physicalSiteList = JSON.parse(JSON.stringify(this.staticDDlist['site']['physicalType']));
        this.apiServerUrl = this.config.StaticImageUrl;
        // setting view mode
        this.route.params.subscribe(params => {
            this.organizationService.getSite(params['id']).subscribe((dataSite) => {
                this.site = JSON.parse(JSON.stringify(dataSite[0]));
                this.assignCardObjects();
                // get organization and filter all of the associates of this site
                this.organizationService.getOrganization(this.site.organizationId).subscribe((data) => {
                    this.organization = data['data'][0];
                    this.site.siteDetails.company.name = this.organization.company.companyName;
                    this.associateService.getAssociateBySiteId(this.site._id).subscribe(siteAssociates => {
                        console.log('site associates', siteAssociates)
                        this.siteAssociates = Object.assign([], siteAssociates['data']);
                    })
                    //   this.siteAssociates = data['data'][0].associates.filter(assc =>{ 
                    //     if (assc.siteId === this.site._id && assc.active !== false) {
                    //       return assc;
                    //   }
                    // });
                    this.hrLeaderId = data['data'][0].companyLeaderShip.hrLeader.id;
                    this.companyLeaderId = data['data'][0].companyLeaderShip.companyLeader.id;
                    if (this.authService.user.associateId === this.hrLeaderId ||
                        this.authService.user.associateId === this.companyLeaderId ||
                        (this.organization.companyLeaderShip.hrTeamIds.indexOf(this.authService.user.associateId) > -1)) {
                        this.isLeader = true;
                        this.isAssociate = false;
                        this.isAdmin = false;
                    } else if (this.authService.user.role === 'Admin') {
                        this.isAdmin = true;
                        this.isLeader = false;
                        this.isAssociate = false;
                    } else {
                        this.isLeader = false;
                        this.isAdmin = false;
                        this.isAssociate = true;
                    }
                }, (error) => { });
            }, (error) => {
                console.log(error);
            });
            if (params['action'] === 'view') {
                this.isLeader = false;
                this.isAdmin = false;
                this.isAssociate = true;
            } else { }
        });
        // Getting data for the site
        // drop down data to display
        this.dropDowns = this.staticDDlistService.staticData.staticDD
        this.errors = this.staticDDlistService.errors;
        this.site = JSON.parse(JSON.stringify(this.route.snapshot.data['site'][0]));
        this.assignCardObjects();
    }

    edit(cardObject: string, editVariable: string, editMode: Boolean) {
        this[editVariable] = editMode;
        if (!editMode) {
            this[cardObject] = JSON.parse(JSON.stringify(this.site[cardObject]));
        }
    }

    save(cardObj: string, editVariable: string) {
        this[cardObj].validated = 1;
        // setting credentials of the editor for record keeping
        // tslint:disable-next-line:max-line-length
        this[cardObj].lastEditedBy.name = this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name;
        this[cardObj].lastEditedBy.id = this.authService.user.associateId;
        this[cardObj].lastEditedBy.time = new Date();
        this.site[cardObj] = JSON.parse(JSON.stringify(this[cardObj]));
        this.site.lastEdited.push(this[cardObj].lastEditedBy);
        this.update();
        // ------------------
        this[editVariable] = false;
    }

    update() {
        this.organizationService.updateSite(this.site).subscribe((data) => {
            // send notifications to company Leaders and all of the sites' associates
            let peopleToSendNotifications = {};
            peopleToSendNotifications[this.companyLeaderId] = this.companyLeaderId;
            peopleToSendNotifications[this.hrLeaderId] = this.hrLeaderId;
            peopleToSendNotifications[this.site.contactDetails.siteLeader.id] = this.site.contactDetails.siteLeader.id;
            this.organization.companyLeaderShip.hrTeamIds.forEach(element => {
                peopleToSendNotifications[element] = element;
            });
            for (let leaderId in peopleToSendNotifications) {
                if (peopleToSendNotifications.hasOwnProperty(leaderId)) {
                    this.notificationService.sendNotification(leaderId,
                        `Site <b>${this.site.siteDetails.siteName}</b> has been updated`, 'Organization',
                        `home/organization/site-profile/view/${this.site._id}`);
                }
            }
            this.siteAssociates.forEach(assc => {
                this.notificationService.sendNotification(assc.associateId,
                    `Site <b>${this.site.siteDetails.siteName}</b> has been updated`, 'Organization',
                    `home/organization/site-profile/view/${this.site._id}`);
            });
            // send notification if site leader has changed
            if (this.originalSiteLeaderId !== this.site.contactDetails.siteLeader.id) {
                this.notificationService.sendNotification(this.site.contactDetails.siteLeader.id,
                    `Site <b>${this.site.siteDetails.siteName}</b> has been updated`, 'Organization',
                    `home/organization/site-profile/view/${this.site._id}`);
            }

            this.toastService.success();
        }, (error) => {
            this.toastService.error(this.errors.Server['501']);
        });
    }

    // validate individual cards
    validate(cardObj: string, validateMode: Boolean) {
        this[cardObj].validated = validateMode ? 2 : 0;
        this.site[cardObj] = Object.assign({}, this[cardObj]);
        // setting credentials of validator for record keeping
        this.site[cardObj].lastValidatedBy.name = this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name;
        this.site[cardObj].lastValidatedBy.id = this.authService.user.associateId;
        this.site[cardObj].lastValidatedBy.time = new Date();
        this.update();
    }

    openDialog(field: string): void {
        const dialogRef = this.dialog.open(DeletePopupComponent, {
            width: '350px',
            data: { name: 'Site' }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'Cancel') {
            } else if (result === 'Proceed') {
                if (field === 'archive') {
                    this.markInactive();
                } else if (field === 'unArchive') {
                    this.unArchive();
                }
            }
        });
    }

    markInactive() {
        if (this.siteAssociates.length === 0) {
            this.site.active = false;
            this.site.lastArchivedBy = Object.assign({}, {
                'name': this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name,
                'id': this.authService.user.associateId, 'time': new Date()
            });
            this.site.lastArchived.push({
                'name': this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name,
                'id': this.authService.user.associateId, 'time': new Date()
            });
            this.organizationService.markSiteAsInactive(this.site._id,this.organization._id).subscribe((markInactive) => {
                this.organizationService.updateSite(this.site).subscribe((updateData) => {
                    this.notificationService.sendNotification(this.organization.companyLeaderShip.hrLeader.id,
                        `The Site <b>${this.site.siteDetails.siteName}</b> is now Archived`, 'Organization',
                        `home/associate/feed`);
                    this.notificationService.sendNotification(this.organization.companyLeaderShip.companyLeader.id,
                        `The Site <b>${this.site.siteDetails.siteName}</b> is now Archived`, 'Organization',
                        `home/associate/feed`);
                    this.notificationService.sendNotification(this.site.contactDetails.siteLeader.id,
                        `The Site <b>${this.site.siteDetails.siteName}</b> is now Archived`, 'Organization',
                        `home/associate/feed`);
                    this.router.navigate(['/home/organization/profile/view', this.site['organizationId']]);
                    // Notify admin that site has been deleted
                    this.toastService.success();
                }, (err) => {
                    console.log(err);
                    this.toastService.error('Site could not be archived');
                });
            }, (error) => {
                console.log(error);
            });
        } else {
            this.toastService.success();
        }
    }

    unArchive() {
        this.organizationService.unarchiveSite(this.site._id).subscribe((data) => {
            this.router.navigate(['/home/organization/profile/view', this.site['organizationId']]);
            this.toastService.success()
            // this.matSnackBar.open('Site has been unarchived.', '', {
            //     duration: 3000
            // });
        }, (error) => {
            console.log(error);
        })
    }

    // autocomplete functions
    initialAssociates(event) {
        this.associateService.getAllAssociatesFilter('a', 'initial').subscribe((data) => {
            this.autoCompleteAssociate = data;
        }, (error) => {
        });
    }

    managerTyped(fieldName: string) {
        this.keyCounterAssc++;
        if (this.keyCounterAssc >= 3) {
            this.associateService.getAllAssociatesFilter(this.contactDetails.siteLeader.name, '', '').pipe(
                debounceTime(500))
                .subscribe((data) => {
                    this.autoCompleteAssociate = data;
                }, (error) => {
                });
            this.keyCounterAssc = 0;
        }
    }

    validateAssociateAutocomplete(field: string, fieldValidate: string) {
        let asscObj: any = this.autoCompleteAssociate.filter((assc) => {
            return assc.personalInformation.fullName === this.site.contactDetails.siteLeader.name
        });
        if (asscObj.length === 0) {
            this[fieldValidate] = false;
        } else {
            this[fieldValidate] = true;
        }
    }

    clickDropDown(recievedAssociate: any, field: string) {
        this.contactDetails.siteLeader.name = recievedAssociate.personalInformation.fullName;
        this.contactDetails.siteLeader.id = recievedAssociate._id;
        this.contactDetails.siteLeader.groupId = recievedAssociate.groupId;
    }
    backBtnClick() {
        this._location.back();
    }

    onTypeChange() {
        if (this.siteDetails.siteType === 'Physical') {
            this.sitePurposeDropDown = Object.assign([], this.physicalSiteList);
            this.siteDetails.sitePurpose = '';
        } if (this.siteDetails.siteType === 'Digital') {
            this.sitePurposeDropDown = Object.assign([], this.digitalSiteList);
            this.siteDetails.sitePurpose = '';
        }
    }

    addressInput(address: any) {
        if (address.field === 'physicalAddress') {
            this.siteDetails.physicalAddress.address1 = address.address.address1;
            this.siteDetails.physicalAddress.address2 = address.address.address2;
            this.siteDetails.physicalAddress.address3 = address.address.address3;
            this.siteDetails.physicalAddress.city = address.address.city;
            this.siteDetails.physicalAddress.zip = address.address.zip;
            this.siteDetails.physicalAddress.state = address.address.state;
            this.siteDetails.physicalAddress.country = address.address.country;
            for (let adf in this.siteDetails.physicalAddress) {
                if (this.siteDetails.physicalAddress.hasOwnProperty(adf)) {
                    if (this.siteDetails.physicalAddress[adf] == undefined) {
                        this.siteDetails.physicalAddress[adf] = '';
                    }
                }
            }
        }
        if (address.field === 'currentLocation') {
            this.siteDetails.currentLocation.address1 = address.address.address1;
            this.siteDetails.currentLocation.address2 = address.address.address2;
            this.siteDetails.currentLocation.address3 = address.address.address3;
            this.siteDetails.currentLocation.city = address.address.city;
            this.siteDetails.currentLocation.zip = address.address.zip;
            this.siteDetails.currentLocation.state = address.address.state;
            this.siteDetails.currentLocation.country = address.address.country;
            for (let adf in this.siteDetails.currentLocation) {
                if (this.siteDetails.currentLocation.hasOwnProperty(adf)) {
                    if (this.siteDetails.currentLocation[adf] == undefined) {
                        this.siteDetails.currentLocation[adf] = '';
                    }
                }
            }
        }
    }


    sortData(sort: Sort) {
        let data = Object.assign([], this.siteAssociates);
        if (!sort.active || sort.direction === '') {
            this.siteAssociates = data['data'][0].associates.filter(assc => assc.siteId === this.site._id);
            return;
        }
        let isAsc = sort.direction === 'asc';
        let sortedList = data.sort((a, b) => {
            switch (sort.active) {
                case 'name': return this.compare(a.name.toLowerCase(), b.name.toLowerCase(), isAsc);
                case 'jobCategory': return this.compare(a.jobCategory.toLowerCase(), b.jobCategory.toLowerCase(), isAsc);
                default: return 0;
            }
        });
        this.siteAssociates = sortedList;
    }

    compare(a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }


}

